import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { sectionNumber } from '../interpretiveReportView';
import { SectionHead } from './SectionHead';
import styles from '../InterpretiveReportPage.module.css';

const GUIDE_CARDS = ['archetype', 'dimensions', 'spread', 'trajectory'] as const;

export const ReportGuide = ({ number }: { number: string }) => {
  const { t } = useTranslation();
  return (
    <section>
      <SectionHead
        number={number}
        eyebrow={t('interpretiveReport.document.guide.eyebrow')}
        title={t('interpretiveReport.document.guide.title')}
        intro={t('interpretiveReport.document.guide.intro')}
      />
      <div className={styles.twoColumns}>
        {GUIDE_CARDS.map((card, index) => (
          <div key={card} className={cn(styles.guideCard, styles.keep)}>
            <span className={styles.cardNumber}>{sectionNumber(index)}</span>
            <h3 className={styles.cardTitle}>{t(`interpretiveReport.document.guide.${card}Title`)}</h3>
            <p className={styles.cardText}>{t(`interpretiveReport.document.guide.${card}Text`)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
